import * as i0 from '@angular/core';
import { Directive, Host, Self, Optional, Input, NgModule } from '@angular/core';
import { _countGroupLabelsBeforeOption, _getOptionScrollPosition } from '@angular/material/core';
import * as i1 from '@angular/material/autocomplete';
import * as i1$1 from '@angular/material/select';

class XpoSelectTwoLinesContainer {
}
XpoSelectTwoLinesContainer.ɵfac = function XpoSelectTwoLinesContainer_Factory(t) { return new (t || XpoSelectTwoLinesContainer)(); };
XpoSelectTwoLinesContainer.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoSelectTwoLinesContainer, selectors: [["xpo-select-two-lines-container"], ["xpoSelectTwoLinesContainer"]], hostAttrs: [1, "xpo-Select-twoLinesContainer"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSelectTwoLinesContainer, [{
        type: Directive,
        args: [{
                selector: 'xpo-select-two-lines-container , xpoSelectTwoLinesContainer',
                host: {
                    class: 'xpo-Select-twoLinesContainer',
                },
            }]
    }], null, null); })();

class XpoSelectTwoColumnsContainer {
}
XpoSelectTwoColumnsContainer.ɵfac = function XpoSelectTwoColumnsContainer_Factory(t) { return new (t || XpoSelectTwoColumnsContainer)(); };
XpoSelectTwoColumnsContainer.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoSelectTwoColumnsContainer, selectors: [["xpo-select-two-columns-container"], ["xpoSelectTwoColumnsContainer"]], hostAttrs: [1, "xpo-Select-twoColumnsContainer"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSelectTwoColumnsContainer, [{
        type: Directive,
        args: [{
                selector: 'xpo-select-two-columns-container , xpoSelectTwoColumnsContainer',
                host: {
                    class: 'xpo-Select-twoColumnsContainer',
                },
            }]
    }], null, null); })();

class XpoAutocompleteInternalActiveNavigation {
    constructor(xpoAutocompleteTrigger) {
        this.xpoAutocompleteTrigger = xpoAutocompleteTrigger;
        this.AUTOCOMPLETE_OPTION_HEIGHT = 24.5;
        this.AUTOCOMPLETE_PANEL_HEIGHT = 256; // Value deprecated in Angular Material
        this.xpoPanelHeight = this.AUTOCOMPLETE_PANEL_HEIGHT;
        this.xpoOptionHeight = this.AUTOCOMPLETE_OPTION_HEIGHT;
    }
    ngOnInit() {
        if (!this.xpoAutocompleteTrigger) {
            return;
        }
        this.xpoAutocompleteTrigger['_scrollToOption'] = this.setOptionScroll.bind(this.xpoAutocompleteTrigger, this.xpoOptionHeight, this.xpoPanelHeight);
    }
    // With the amounts of options that preceds the active option and the scrollTop we set the scroll position
    setOptionScroll(xpoOptionHeight, xpoPanelHeight) {
        const index = this.autocomplete._keyManager.activeItemIndex || 0;
        // Counts the amount of option group labels that precede the specified option
        const xpoAutocompleteLabelCount = _countGroupLabelsBeforeOption(index, this.autocomplete.options, this.autocomplete.optionGroups);
        // If there is only one option set scroll top 0
        if (index === 0 && xpoAutocompleteLabelCount === 1) {
            this.autocomplete._setScrollTop(0);
        }
        else {
            // Set scroll position
            const xpoAutocompleteNewScrollPosition = _getOptionScrollPosition(index + xpoAutocompleteLabelCount, xpoOptionHeight, this.autocomplete._getScrollTop(), xpoPanelHeight);
            this.autocomplete._setScrollTop(xpoAutocompleteNewScrollPosition);
        }
    }
}
XpoAutocompleteInternalActiveNavigation.ɵfac = function XpoAutocompleteInternalActiveNavigation_Factory(t) { return new (t || XpoAutocompleteInternalActiveNavigation)(i0.ɵɵdirectiveInject(i1.MatAutocompleteTrigger, 11)); };
XpoAutocompleteInternalActiveNavigation.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoAutocompleteInternalActiveNavigation, selectors: [["", "xpoAutocomplete", ""], ["", "xpo-autocomplete", ""]], inputs: { xpoOptionHeight: "xpoOptionHeight", xpoPanelHeight: "xpoPanelHeight" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAutocompleteInternalActiveNavigation, [{
        type: Directive,
        args: [{
                selector: '[xpoAutocomplete] , [xpo-autocomplete]',
            }]
    }], function () { return [{ type: i1.MatAutocompleteTrigger, decorators: [{
                type: Host
            }, {
                type: Self
            }, {
                type: Optional
            }] }]; }, { xpoOptionHeight: [{
            type: Input
        }], xpoPanelHeight: [{
            type: Input
        }] }); })();

/**
 * Disabling material's shifting of the select option panel when selecting a value.
 */
class XpoDisableOptionCenteringDirective {
    constructor(select) {
        this.select = select;
        this.panelClasses = ['xpo-Select-panel', 'xpo-Select-panelMultiple'];
        this.existingPanelClasses = '';
    }
    ngOnInit() {
        this.select.disableOptionCentering = true;
        // Getting the existing panel class or classes and transforming
        // them into a class string. This will be added to our
        // custom panel classes
        if (this.select.panelClass) {
            this.existingPanelClasses = Array.isArray(this.select.panelClass)
                ? ` ${this.select.panelClass.join(' ')}`
                : ` ${this.select.panelClass.toString()}`;
        }
        // Setting custom classes to facilitate style overriding.
        // We are keeping all classes added by the projects
        this.select.panelClass = `${this.select.multiple ? this.panelClasses.join(' ') : this.panelClasses[0]} ${this.existingPanelClasses}`;
    }
}
XpoDisableOptionCenteringDirective.ɵfac = function XpoDisableOptionCenteringDirective_Factory(t) { return new (t || XpoDisableOptionCenteringDirective)(i0.ɵɵdirectiveInject(i1$1.MatSelect)); };
XpoDisableOptionCenteringDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoDisableOptionCenteringDirective, selectors: [["mat-select"]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDisableOptionCenteringDirective, [{
        type: Directive,
        args: [{
                selector: 'mat-select',
            }]
    }], function () { return [{ type: i1$1.MatSelect }]; }, null); })();

class XpoOptionHideDividerDirective {
    constructor() {
        this.xpoOptionHideDivider = true;
    }
}
XpoOptionHideDividerDirective.ɵfac = function XpoOptionHideDividerDirective_Factory(t) { return new (t || XpoOptionHideDividerDirective)(); };
XpoOptionHideDividerDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoOptionHideDividerDirective, selectors: [["", "xpoOptionHideDivider", ""]], hostVars: 2, hostBindings: function XpoOptionHideDividerDirective_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("xpo-Option-hideDivider", ctx.xpoOptionHideDivider);
    } }, inputs: { xpoOptionHideDivider: "xpoOptionHideDivider" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoOptionHideDividerDirective, [{
        type: Directive,
        args: [{
                selector: '[xpoOptionHideDivider]',
                host: {
                    '[class.xpo-Option-hideDivider]': 'xpoOptionHideDivider',
                },
            }]
    }], null, { xpoOptionHideDivider: [{
            type: Input,
            args: ['xpoOptionHideDivider']
        }] }); })();

class XpoOptionTwoLinesDirective {
}
XpoOptionTwoLinesDirective.ɵfac = function XpoOptionTwoLinesDirective_Factory(t) { return new (t || XpoOptionTwoLinesDirective)(); };
XpoOptionTwoLinesDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoOptionTwoLinesDirective, selectors: [["", "xpoOptionTwoLines", ""], ["", "xpo-option-two-lines", ""]], hostAttrs: [1, "xpo-Option--twoLines"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoOptionTwoLinesDirective, [{
        type: Directive,
        args: [{
                selector: '[xpoOptionTwoLines], [xpo-option-two-lines]',
                host: {
                    class: 'xpo-Option--twoLines',
                },
            }]
    }], null, null); })();

class XpoSelectTwoLinesDirective {
    // We need to override _getItemHeight function so the navigation between the
    // options works correctly. Have in mind that in case the height of the
    // options is changed, this value will have to change as well.
    constructor(matSelect) {
        this.matSelect = matSelect;
        this.MAT_SELECT_DEFAULT_HEIGHT = 45;
        this.matSelect._getItemHeight = () => this.MAT_SELECT_DEFAULT_HEIGHT;
    }
}
XpoSelectTwoLinesDirective.ɵfac = function XpoSelectTwoLinesDirective_Factory(t) { return new (t || XpoSelectTwoLinesDirective)(i0.ɵɵdirectiveInject(i1$1.MatSelect)); };
XpoSelectTwoLinesDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoSelectTwoLinesDirective, selectors: [["", "xpo-select-two-lines", ""], ["", "xpoSelectTwoLines", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSelectTwoLinesDirective, [{
        type: Directive,
        args: [{
                selector: '[xpo-select-two-lines], [xpoSelectTwoLines]',
            }]
    }], function () { return [{ type: i1$1.MatSelect }]; }, null); })();

class XpoSelectDirective {
    // We need to override _getItemHeight function so the navigation between the
    // options works correctly. Have in mind that in case the height of the
    // options is changed, this value will have to change as well.
    constructor(matSelect) {
        this.matSelect = matSelect;
        this.MAT_SELECT_DEFAULT_HEIGHT = 30;
        this.matSelect._getItemHeight = () => this.MAT_SELECT_DEFAULT_HEIGHT;
    }
}
XpoSelectDirective.ɵfac = function XpoSelectDirective_Factory(t) { return new (t || XpoSelectDirective)(i0.ɵɵdirectiveInject(i1$1.MatSelect)); };
XpoSelectDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoSelectDirective, selectors: [["", "xpo-select", ""], ["", "xpoSelect", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSelectDirective, [{
        type: Directive,
        args: [{
                selector: '[xpo-select], [xpoSelect]',
            }]
    }], function () { return [{ type: i1$1.MatSelect }]; }, null); })();

class XpoSelectThreeColumnsContainer {
}
XpoSelectThreeColumnsContainer.ɵfac = function XpoSelectThreeColumnsContainer_Factory(t) { return new (t || XpoSelectThreeColumnsContainer)(); };
XpoSelectThreeColumnsContainer.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoSelectThreeColumnsContainer, selectors: [["xpo-select-three-columns-container"], ["xpoSelectThreeColumnsContainer"]], hostAttrs: [1, "xpo-Select-threeColumnsContainer"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSelectThreeColumnsContainer, [{
        type: Directive,
        args: [{
                selector: 'xpo-select-three-columns-container, xpoSelectThreeColumnsContainer',
                host: {
                    class: 'xpo-Select-threeColumnsContainer',
                },
            }]
    }], null, null); })();

class XpoSelectModule {
}
XpoSelectModule.ɵfac = function XpoSelectModule_Factory(t) { return new (t || XpoSelectModule)(); };
XpoSelectModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoSelectModule });
XpoSelectModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSelectModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    XpoDisableOptionCenteringDirective,
                    XpoSelectTwoLinesContainer,
                    XpoSelectTwoColumnsContainer,
                    XpoAutocompleteInternalActiveNavigation,
                    XpoOptionHideDividerDirective,
                    XpoOptionTwoLinesDirective,
                    XpoSelectDirective,
                    XpoSelectTwoLinesDirective,
                    XpoSelectThreeColumnsContainer,
                ],
                exports: [
                    XpoDisableOptionCenteringDirective,
                    XpoSelectTwoLinesContainer,
                    XpoSelectTwoColumnsContainer,
                    XpoAutocompleteInternalActiveNavigation,
                    XpoOptionHideDividerDirective,
                    XpoOptionTwoLinesDirective,
                    XpoSelectDirective,
                    XpoSelectTwoLinesDirective,
                    XpoSelectThreeColumnsContainer,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoSelectModule, { declarations: [XpoDisableOptionCenteringDirective,
        XpoSelectTwoLinesContainer,
        XpoSelectTwoColumnsContainer,
        XpoAutocompleteInternalActiveNavigation,
        XpoOptionHideDividerDirective,
        XpoOptionTwoLinesDirective,
        XpoSelectDirective,
        XpoSelectTwoLinesDirective,
        XpoSelectThreeColumnsContainer], exports: [XpoDisableOptionCenteringDirective,
        XpoSelectTwoLinesContainer,
        XpoSelectTwoColumnsContainer,
        XpoAutocompleteInternalActiveNavigation,
        XpoOptionHideDividerDirective,
        XpoOptionTwoLinesDirective,
        XpoSelectDirective,
        XpoSelectTwoLinesDirective,
        XpoSelectThreeColumnsContainer] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoAutocompleteInternalActiveNavigation, XpoDisableOptionCenteringDirective, XpoOptionHideDividerDirective, XpoOptionTwoLinesDirective, XpoSelectDirective, XpoSelectModule, XpoSelectThreeColumnsContainer, XpoSelectTwoColumnsContainer, XpoSelectTwoLinesContainer, XpoSelectTwoLinesDirective };
